import React from 'react';
import './card.css'
import CategoryChip from './chip';
import person from './../../assets/cap.svg'
import Button from './button';
const EventCard = (props) => {
    return ( <>
     <div className="eventCard moveIn scrollAnimate">
        <CategoryChip class="inactive absolute" title={props.statustxt} />
        <img className='eventimg' src={props.img} alt="" />
        <div className="eventDeets">
            <h3 className='h3_2'>
                {props.title}
            </h3>
            <div className="detailsflex">
                <div className="deet">
                {props.date} | {props.time}
            </div>
            <div className="deet">
                {props.location} 
            </div>
            </div>
            <div className="descCont">
                <p>
                {props.description}
            </p>
            </div>
            <div className="eventCTA">
                <h2>
                    {props.price}<span>EGP
                </span>
                </h2>
                <h3 className='capacity'>
                   <img src={person} alt="" /> 1K
                </h3>
            </div>
        <Button class="btn1 btn4" cta="Book Now" />
        </div>
    </div>
    </>);
}
 
export default EventCard;